import { Directive, OnInit, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[truefalse]'
})
export class TrueFalseDirective  {

  private el: HTMLInputElement;
  _status;

  @Input() set inputValue(value) {
    if (value !== this._status) {
      this._status = value;
      this._setValue();
    }
  }

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  private _setValue(): void {
    let item = null;
    if (this._status == 'false' || this._status == false || this._status == null) item = false;
    else if (this._status == 'true' || this._status == true) item = true;
    this.el.value = item ? 'SIM' : 'NÃO'
  }
}
